// redux/Slices/userSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { config } from '../../config';

export const fetchUserByUsername = createAsyncThunk(
    'user/fetchUserByUsername',
    async (username, { rejectWithValue }) => {
        try {
            const response = await fetch(`${config.API_URI}/v1/users/username/${username}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error('Invalid token or user not found');
            }

            const data = await response.json();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const switchAccount = createAsyncThunk(
    'user/switchAccount',
    async (targetUserId, { rejectWithValue }) => {
        try {
            const response = await fetch(`${config.API_URI}/v1/users/switch-account`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ targetUserId })
            });

            if (!response.ok) {
                throw new Error('Failed to switch account');
            }

            const data = await response.json();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


const userSlice = createSlice({
    name: 'user',
    initialState: {
        user: null,
        userInfo: null,
        loading: false,
        error: null,
    },
    reducers: {
        fetchUserStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchUserSuccess: (state, action) => {
            state.loading = false;
            state.user = action.payload;
        },
        fetchUserFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        switchAccountStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        switchAccountSuccess: (state, action) => {
            state.loading = false;
            state.user = action.payload;
        },
        switchAccountFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        clearUser: (state) => {
            state.user = null;
            state.userInfo = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserByUsername.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserByUsername.fulfilled, (state, action) => {
                state.loading = false;
                state.userInfo = action.payload;
            })
            .addCase(fetchUserByUsername.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(switchAccount.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(switchAccount.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
            })
            .addCase(switchAccount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const {
    fetchUserStart,
    fetchUserSuccess,
    fetchUserFailure,
    switchAccountStart,
    switchAccountSuccess,
    switchAccountFailure,
    clearUser
} = userSlice.actions;
export default userSlice.reducer;
